import DocumentBrowser from "../../components/DocumentBrowser/DocumentBrowser";
import Menu from "../../components/Menu/Menu";

function GaldermaDataCatalogue() {
    const menuItems = [
        {
          name: "Home",
          link: "/",
        },
        {
          name: "Dashboard",
          link: "/dashboard",
        },
        {
          name: "Data Catalogue",
          link: "/data-catalogue",
        },
      ];
  return (
    <>
      <Menu menuItems={menuItems}></Menu>
      <DocumentBrowser containerName={"galderma-documents"} className="mt-4" />
    </>
  );
}
export default GaldermaDataCatalogue;
